import { ActionType, createReducer } from 'typesafe-actions'

import * as Actions from './actions'
import { AgencyPartnersState } from './types'

const INITIAL_STATE: AgencyPartnersState = {
  error: '',
  list: [],
  loading: false,
  request_totals: {
    total_emissions: 0,
    total_quotations: 0
  },
  sendAgencyPartnersError: '',
  sendAgencyPartnersLoading: false,
  total_results: 0
}

const reducer = createReducer<AgencyPartnersState, ActionType<typeof Actions>>(
  INITIAL_STATE
)
  .handleAction(Actions.getAgencyPartners, state => ({
    ...state,
    error: '',
    loading: true
  }))
  .handleAction(Actions.getAgencyPartnersFailure, (state, { payload }) => ({
    ...state,
    error: payload.message,
    loading: false
  }))
  .handleAction(Actions.getAgencyPartnersSuccess, (state, { payload }) => ({
    ...state,
    list: [...payload.agency_partners],
    loading: false
  }))
  .handleAction(Actions.sendAgencyPartners, state => ({
    ...state,
    sendAgencyPartnersError: '',
    sendAgencyPartnersLoading: true
  }))
  .handleAction(Actions.sendAgencyPartnersFailure, (state, { payload }) => ({
    ...state,
    sendAgencyPartnersError: payload.message,
    sendAgencyPartnersLoading: false
  }))
  .handleAction(Actions.sendAgencyPartnersSuccess, state => ({
    ...state,
    sendAgencyPartnersLoading: false
  }))

export default reducer
